import { render } from "./WindowDocuments.vue?vue&type=template&id=0d22599e&scoped=true"
import script from "./WindowDocuments.vue?vue&type=script&lang=js"
export * from "./WindowDocuments.vue?vue&type=script&lang=js"

import "./WindowDocuments.vue?vue&type=style&index=0&id=0d22599e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0d22599e"

export default script